/**
 * One id per "pull jobs from" choice. A job portal's entry arrives as
 * `source: 'manual'` plus the portal's key in `board`, so the source alone no
 * longer tells two entries apart: portals are addressed as `board:<key>`.
 */

import type { JobSourceOption } from '@/types/api'

const BOARD_PREFIX = 'board:'

export const sourceOptionId = (option: Pick<JobSourceOption, 'source' | 'board'>): string =>
  option.board ? `${BOARD_PREFIX}${option.board}` : option.source

export const boardOptionId = (boardKey: string): string => `${BOARD_PREFIX}${boardKey}`

/** The `sources` / `boards` query filters for a chosen id (`all` or null = no filter). */
export function sourceFilterFor(id: string | null | undefined): {
  sources?: string[]
  boards?: string[]
} {
  if (!id || id === 'all') return {}
  return id.startsWith(BOARD_PREFIX)
    ? { boards: [id.slice(BOARD_PREFIX.length)] }
    : { sources: [id] }
}

/** Browse Jobs, pre-filtered to the chosen id. */
export function browseJobsHref(id: string | null | undefined): string {
  const { sources, boards } = sourceFilterFor(id)
  if (boards?.[0]) return `/dashboard/jobs?board=${encodeURIComponent(boards[0])}`
  if (sources?.[0]) return `/dashboard/jobs?source=${encodeURIComponent(sources[0])}`
  return '/dashboard/jobs'
}
